function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M103 0.999985H1L9.44586 14H94.5541L103 0.999985Z",
  stroke: "white",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M103 158H1L9.44586 145H94.5541L103 158Z",
  stroke: "white",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0656 144C10.0656 144 3.16796 118.718 10.0656 104.698C16.445 91.7311 39 79.5039 39 79.5039C39 79.5039 16.1991 65.9607 10.0656 52.2946C3.84766 38.4401 10.0656 14 10.0656 14",
  stroke: "white",
  strokeWidth: 4
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M92.2218 144C92.2218 144 98.4728 118.718 92.2218 104.698C86.4405 91.7311 66 79.5039 66 79.5039C66 79.5039 86.6634 65.9607 92.2218 52.2946C97.8568 38.4401 92.2218 14 92.2218 14",
  stroke: "white",
  strokeWidth: 4
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M7 114C7 114 47.2353 105 51.4706 114C55.7059 123 97 114 97 114",
  stroke: "white",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M10 52C10 52 48 43 52 52C56 61 95 52 95 52",
  stroke: "white",
  fill: "white"
});

function SvgHourglass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 28,
    viewBox: "0 0 104 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.d7514ccd.svg";
export { ForwardRef as ReactComponent };